import React, { FC } from 'react';
import { TSpecCellProps } from '../../../types/index.types';
import CellText from './cellText';
import CellIcon from './cellIcon';

const SpecCell: FC<TSpecCellProps> = (props) => {
  const { specIndex, subObj, lastRow, fadeIn, hide, showHiddenRightCells, heading, eyebrow, isShowIconOnCell } = props;

  if (!showHiddenRightCells && specIndex > 5) return null;

  return (
    <td
      className={`
        model-detail-specification-table__table-cell
        model-detail-specification-table__table-cell--${specIndex % 2 === 0 ? 'even' : 'odd'}
        ${hide || lastRow ? 'model-detail-specification-table__table-cell--border-hidden' : ''}
      `}
    >
      {isShowIconOnCell ? (
        <CellIcon index={specIndex + 1} row={subObj} hideCell={hide} fadeIn={fadeIn} />
      ) : (
        <CellText index={specIndex + 1} row={subObj} heading={heading} eyebrow={eyebrow} hideCell={hide} fadeIn={fadeIn} />
      )}
    </td>
  );
};

export default SpecCell;
